import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import PdtNextBtnWrap from "./PdtNextBtnWrap";

class BtnAfterLoadCustomerSucc extends Component {
  render() {
    const {
      loadCustomerSuccessfully,
      customerData,
      clickNextButtonForCheckEmail
    } = this.props;
    return (
      <>
        {loadCustomerSuccessfully ? (
          <>
            {customerData.customer.email === "NA" ||
            customerData.customer.emailState === "I" ||
            customerData.customer.emailState === "P" ? (
              <button
                className="blockBtn"
                onClick={() =>
                  clickNextButtonForCheckEmail(customerData.customer.emailState)
                }
              >
                <Translation>{t => <>{t(`checkout.next`)}</>}</Translation>
              </button>
            ) : (
              <PdtNextBtnWrap />
            )}
          </>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => ({
  customerData: state.customer.customerData,
  loadCustomerSuccessfully: state.customer.loadCustomerSuccessfully
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BtnAfterLoadCustomerSucc);
